















































import CApexChart from '~/components/shared/configurable/chart/CApexChart.vue'
import { formatNumber } from '~/utils/number'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CApexChart },
  props: {
    stats: {
      type: Object,
      required: true
    },
    cost: {
      type: Number,
      default: 0
    },
    duration: {
      type: String,
      default: ''
    },
    inPrevious: {
      type: Boolean,
      default: false
    },
    paymentType: {
      type: String,
      default: 'credits'
    }
  },
  computed: {
    impressions() {
      return formatNumber(this.stats.total.impressions)
    },
    clicks() {
      return formatNumber(this.stats.total.clicks)
    },
    allClicks() {
      return formatNumber(this.stats.total.all_clicks)
    },
    formatedCost() {
      return formatNumber(this.cost)
    },
    isPaymentTypeStripe() {
      return this.paymentType === 'stripe'
    }
  }
})
